module.exports = __webpack_public_path__ + "img/export-icon-white.0a09a9f2.svg";